import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";

import { ANY_ERROR } from "../../../../action/user_action_types";

import { fileUrl } from "../../../../config";
import SideBar from "../../common/sideBar";
import { history } from "../../../../history/history";

import { getCityState } from "../../../../action/user_action";
import { endPoints } from "../../../../config";
import http from "../../../../util/http";

import { getServerDataWithTypes } from "../../../../action/common_action";
import {
  SALES_USERS_DATA,
  STATE_LIST,
} from "../../../../action/salesUser_action_types";
import { axiosInstnace as Axios } from "../../../../util/util";
// import { Multiselect } from 'multiselect-react-dropdown';
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css";
import HeaderAdminpanel from "../../common/HeaderAdminpanel";

class ViewCluster extends Component {
  constructor(props) {
    super(props);
    
    let clusterData = this.props.location.state.clusterData
      ? this.props.location.state.clusterData
      : undefined;
    this.state = {
      clusterField: {
        email:
          clusterData && clusterData.cluster && clusterData.cluster.email
            ? clusterData.cluster.email
            : "",
        name:
          clusterData && clusterData.cluster && clusterData.cluster.name
            ? clusterData.cluster.name
            : "",
        mobile:
          clusterData && clusterData.cluster && clusterData.cluster.mobile
            ? clusterData.cluster.mobile
            : "",
        stateList:
          clusterData && clusterData.cluster && clusterData.cluster.stateList
            ? clusterData.cluster.stateList
            : "",
        cityList:
          clusterData && clusterData.cluster && clusterData.cluster.cityList
            ? clusterData.cluster.cityList
            : "",
        clusterList:
          clusterData && clusterData.cluster && clusterData.cluster.clusterList
            ? clusterData.cluster.clusterList
            : "",
      },
      redirectLink:clusterData && clusterData.cluster && clusterData.cluster.clusterList.length > 0? 'clusterOfClusterlist':'clusterlist',
      stateList: ["Select State"],
      cityList: ["Select City"],
      districtList: ["Select District"],
      clusterName: "",
      clusterCities:
        clusterData && clusterData.cluster && clusterData.cluster.cityList
          ? clusterData.cluster.cityList
          : [],
      clusterStates: [],
    };
  }


  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  //View campaign info
  render() {
    let { clusterField } = this.state;
    return (
      <div>
        <div className="dashboardContainer">
        <HeaderAdminpanel/>
          <div className="dashboardContainer-inner">
            <section id="sidebar">
              <SideBar />
            </section>
            <section
              id="dashboard-rightContainer"
              className="dashboard-manageSales brands-head"
            >
              <div className="container-head">
                <div className="dashboard-breadcrumb">
                  System Configuration | Cluster List |
                  <span className="blue_camp">Add Cluster</span>
                </div>
              </div>

              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Created By</th>
                    <th>Created On</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{clusterField.name}</td>
                    <td>{clusterField.email}</td>
                    <td>{clusterField.email}</td>
                  </tr>
                </tbody>
              </table>

              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>Cluster Details</th>
                  </tr>
                </thead>
                <tbody>
                  {clusterField.cityList &&
                    clusterField.cityList.map((c, i) => (
                      <tr key={i}>
                        <td>
                          {c.state} - {c.city}
                        </td>
                      </tr>
                    ))}

                  {clusterField.clusterList &&
                    clusterField.clusterList.map((c, i) => (
                      <tr key={i}>
                        <td>
                          {c.name}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>

              <div className="view-btn_wrapper">
                <button
                  className="cluster-add-btn"
                  onClick={() =>
                    this.goToRoute(
                      "salesuser",
                      null,
                      `/admin/${this.state.redirectLink}`
                    )
                  }
                >
                  BACK
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state);
  return {
    stateList: state.sales.get("stateList"),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    getStateList: (url, data, type) =>
      dispatch(getServerDataWithTypes(url, data, type)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ViewCluster);



// WEBPACK FOOTER //
// ./web/components/admin/users/salesUser/viewCluster.jsx